import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";

const ModalMoreInfo = ({
  modalBusinessInfo,
  setModalBusinessInfo,
  submitBusiness,
  businessAddress,
}) => {
  const handleSubmit = async (data) => {
    await submitBusiness(businessAddress, data);
  };

  return (
    <Modal
      title="Encore une petite étape"
      visible={modalBusinessInfo}
      onClose={() => setModalBusinessInfo(false)}
    >
      <FormMoreInfo onSubmit={handleSubmit} submitLabel="Analyser" />
    </Modal>
  );
};

export default ModalMoreInfo;
